module.exports = __webpack_public_path__ + "img/RORBPJR40007.14eda910.png";